import React, { useCallback, useState } from "react";
import { observer } from "mobx-react-lite";

import "./DownloadSewerObjectsModal.scss";
import { translationService } from "../../../services/translation/TranslationService";
import { exportSewerObjectsService } from "../../../services/sewer-object/ExportSewerObjectsService";
import { Dialog } from "../../dialog/Dialog";
import RadioButton from "../../radio-button/RadioButton";

interface DownloadSewerObjectsModalProps {
  projectId?: number;
  jobId?: number;
  sewerObjectIds: number[];
  isVisible: boolean;
  modalTitleKey: string;
  sewerObjectsCount: number;
  fileName: string;
}

export const DownloadSewerObjectsModal = observer(
  (props: DownloadSewerObjectsModalProps) => {
    const [includeInspectionAndDamages, setIncludeInspectionAndDamages] = useState<boolean>(false);
    const [includeMediaFiles, setIncludeMediaFiles] = useState<boolean>(false);

    const { projectId, jobId, sewerObjectIds, isVisible, modalTitleKey, sewerObjectsCount, fileName } = { ...props };

    const downloadSewerObjects = useCallback(async () => {
      await exportSewerObjectsService.exportSewerObjects({
        projectId,
        jobId,
        sewerObjectsCount,
        fileName,
        sewerObjectIds,
        includeInspectionAndDamages,
        includeMediaFiles,
      });
    }, [fileName, includeInspectionAndDamages, includeMediaFiles, jobId, projectId, sewerObjectsCount, sewerObjectIds]);

    return (
      <Dialog
        isVisible={isVisible}
        sidePosition
        onHide={exportSewerObjectsService.hideModal}
        titleKey={modalTitleKey}
        buttonOk={{
          textKey: "general.download",
          action: downloadSewerObjects,
        }}
        buttonCancel={{
          textKey: "general.cancel",
          action: exportSewerObjectsService.hideModal,
        }}
      >
        <div className="download-sewer-objects-modal">
          <span className="subtitle">
            {translationService.translate("sewer-objects.DownloadSewerObjectsModal.subtitle", {
              sewerObjectsCount: sewerObjectsCount,
            })}
          </span>
          <RadioButton
            labelKey="sewer-objects.DownloadSewerObjectsModal.download-option.ObjectInformation"
            onChange={() => {
              setIncludeInspectionAndDamages(false);
              setIncludeMediaFiles(false);
            }}
            checked={!includeInspectionAndDamages && !includeMediaFiles}
            value="object"
          />
          <RadioButton
            labelKey="sewer-objects.DownloadSewerObjectsModal.download-option.ObjectInformationInspectionInformationDamages"
            onChange={() => {
              setIncludeInspectionAndDamages(true);
              setIncludeMediaFiles(false);
            }}
            checked={includeInspectionAndDamages && !includeMediaFiles}
            value="object-inspection-damages"
          />
          <RadioButton
            labelKey="sewer-objects.DownloadSewerObjectsModal.download-option.ObjectInformationInspectionInformationDamagesMediaFiles"
            onChange={() => {
              setIncludeInspectionAndDamages(true);
              setIncludeMediaFiles(true);
            }}
            checked={includeInspectionAndDamages && includeMediaFiles}
            value="object-inspection-damages-media-files"
          />
        </div>
      </Dialog>
    );
  }
);
